/**
 * Применяет ответ входа/регистрации (формат _build_login_response на бэке)
 * к LayoutContext — общий код для страницы входа и анкеты-онбординга.
 */
import { useContext } from 'react';
import Cookies from 'js-cookie';
import { LayoutContext } from '../../context';
import { START_INFO_SHOWN_KEY } from '../../utils';

export default function useAuthSuccess() {
    const {
        setToken, setCurrentUser, setSystemSettings, setProfileStatus,
        setIsVerified, setIsLoginRequired, checkProfileStatus, setModalStartInfo,
    } = useContext(LayoutContext);

    return (response, platform = 'email') => {
        const authToken = response?.token;
        if (!authToken) return;

        Cookies.set('authToken', authToken, { expires: 30 });
        Cookies.set('authPlatform', platform, { expires: 30 });
        localStorage.setItem('authPlatform', platform);

        setToken(authToken);
        setCurrentUser({ ...response?.user, tariff_info: response?.user?.tariff_info });
        setSystemSettings(response?.system_settings);
        // Статус анкеты приходит сразу в ответе — без мигания пустого экрана
        if (response?.profile_status) setProfileStatus(response.profile_status);
        setIsVerified(true);
        setIsLoginRequired(false);
        if (response?.user?.id) checkProfileStatus(authToken, response.user.id);

        const startInfoShown = localStorage.getItem(START_INFO_SHOWN_KEY);
        setModalStartInfo({ open: !startInfoShown });
    };
}
